import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const SDS_AREAS: Layer = {
  id: ConstraintsCategory.SDS_AREAS,
  layerType: ConstraintsLayerType,
  title: "Proposed SDS areas",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.STRATEGIC,
  icon: "lt-layer-sds-areas",
  description: "Spatial development strategy areas",
  hideByDefault: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  layerConfig: {
    rootCategory: ConstraintsCategory.SDS_AREAS,
    minZoom: 6,
    strokeThreshold: 6,
    categorySchema: [
      { key: "proposed_sds_areas_group1" },
      { key: "proposed_sds_areas_group2" },
      { key: "proposed_sds_areas_group3" },
      { key: "proposed_sds_areas_group4" },
    ],
  },
};
